































































































import { Component, Mixins, Vue } from 'vue-property-decorator';
import GExamCreateFormFormat from '../GExamCreateFormFormat.vue';
import GExamCreateMailSettingDate from '@/views/GExamCreate/MailSetting/GExamCreateMailSettingDate.vue';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { GPageBase } from '@/mixins';
import GVTag from '@/components/GVTag.vue';
import { EvalSettingMail } from '@/models/evalSetting/eval-setting-mail';
import { teacherModule } from '@/store/modules/entities/teacher.module';
import { Teacher } from '@/models/teacher/teacher';
import { globalModule } from '@/store/modules/global.module';
import moment from 'moment';
import { GEnum } from '@/constants/enum.defination';
import { TeacherSearch } from '@/models/teacher/teacher-search';

@Component({
  name: 'GExamCreateMailSetting',
  components: {
    GVTag,
    GExamCreateFormFormat,
    GExamCreateMailSettingDate,
  },
  computed: {},
  methods: {},
})
export default class GExamCreateMailSetting extends Mixins(GPageBase) {
  facultyListColumn: object[] = [];
  isTeacherRequired: boolean = false;
  isSelectedDateRequired: boolean = false;
  teacherAll: boolean = false;
  viewTeachers: Teacher[] = this.teachers;

  async mounted() {
    // 受検一覧画面から直接「メール設定画面」に飛んできた場合、先生リストが取得されていない場合がある
    if (this.teachers.length < 1) {
      // メール設定用に先生一覧を取得
      await teacherModule.fetchTeacherList({} as TeacherSearch);
      this.viewTeachers = this.teachers;
    }

    if (this.teachers.length === this.mailSettingTeacherIDs.length) {
      this.teacherAll = true;
    }
  }

  get teachers(): Teacher[] {
    let tempTeachers: Teacher[] = [];
    tempTeachers = teacherModule.validTeachers;
    return tempTeachers.filter((teacher: Teacher) => {
      return true;
    });
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get mailSetting(): EvalSettingMail {
    return this.evalSettingDetail.mailSetting;
  }

  get mailSettingEnable(): boolean {
    return this.mailSetting.mailEnable;
  }

  get mailSettingDates(): Date[] {
    return this.mailSetting.dates;
  }

  get mailSettingTeacherIDs(): number[] {
    return this.mailSetting.ids;
  }

  get isMailSettingSendRegularlyView(): boolean {
    return this.mailSetting.sendRegularlyView === GEnum.RadioLabel.True ? true : false;
  }

  get mailSettingSendRegularlyView(): GEnum.RadioLabel {
    return this.mailSetting.sendRegularlyView;
  }

  set mailSettingSendRegularlyView(val: GEnum.RadioLabel) {
    this.mailSetting.sendRegularlyView = val;
  }

  get isValid(): boolean {
    let valid = true;
    // メール設定が「有効」の場合、
    // 1. 送信先の先生が設定されていない場合にエラー
    // 2. 送信日「指定日」が設定されている場合に、日付が何も選択されていない場合エラー
    if (this.mailSettingEnable) {
      // 送信先となる先生が未設定
      if (this.mailSettingTeacherIDs.length === 0) {
        // 送信先の先生（ID）が0件なのでエラーとする
        valid = false;
        // エラーメッセージの表示
        this.isTeacherRequired = true;
      } else {
        // エラーメッセージのクリア
        this.isTeacherRequired = false;
      }

      // 月曜定期送信でない（指定日送信である）場合
      if (!this.isMailSettingSendRegularlyView) {
        if (this.mailSettingDates.length === 0) {
          valid = false;
          this.isSelectedDateRequired = true;
        } else {
          this.isSelectedDateRequired = false;
        }
      }
    }

    return valid;
  }

  // iviewのDatePickerのoptionsに入れるオブジェクト
  get dateOption() {
    const now: Date = new Date();
    const startDate: Date = this.evalSettingDetail.startTime > now ? this.evalSettingDetail.startTime : new Date();
    const endDate: Date = this.evalSettingDetail.deadline;
    const startDateMoment = moment(startDate).add(1, 'days');
    const endDateMoment = moment(endDate);
    return {
      disabledDate(date: Date) {
        // 開始日（startDate）より以前、終了日（endDate）より以降であれば true を返す => disabled
        // 「開始日以前」または「終了日以降」であれば選択不可
        return (date && moment(date).isBefore(startDateMoment, 'day')) || moment(date).isAfter(endDateMoment, 'day');
      },
    };
  }

  /**
   * 時間設定
   * iview のコンポーネントから来る value は、yyyy-mm-dd がカンマ区切りとなった文字列
   */
  handleSetDate(value: string) {
    // 初期化して新たな date オブジェクトを挿入する
    this.mailSetting.dates = [];
    if (value) {
      value.split(',').forEach(d => {
        this.mailSetting.dates.push(moment(d).toDate());
      });
    }
  }

  handleSeachTeacherName(e: any) {
    const searchWord = e.target.value;
    const teachers = this.teachers.filter((teacher: Teacher) => {
      // 姓 + " " + 名 半角スペースと全角スペースの2パターンのいずれかにマッチするもの
      const fullName1 = teacher.lastName + " " + teacher.firstName;
      const fullName2 = teacher.lastName + "　" + teacher.firstName;
      if (fullName1.includes(searchWord) || fullName2.includes(searchWord)) {
        return teacher;
      }
    });
    this.viewTeachers = teachers;
    let allChecked = true;
    this.viewTeachers.forEach((teacher: Teacher) => {
      if (this.mailSettingTeacherIDs.indexOf(teacher.teacherID) < 0) {
        allChecked = false;
      }
    });
    this.teacherAll = allChecked;
  }

  handleSeachTeacherEmail(e: any) {
    const searchWord = e.target.value;
    const teachers = this.teachers.filter((teacher: Teacher) => {
      console.log(teacher.lastName);
      if (teacher.email.indexOf(searchWord) > -1) {
        return teacher;
      }
    });
    this.viewTeachers = teachers;
    let allChecked = true;
    this.viewTeachers.forEach((teacher: Teacher) => {
      if (this.mailSettingTeacherIDs.indexOf(teacher.teacherID) < 0) {
        allChecked = false;
      }
    });
    this.teacherAll = allChecked;
  }

  handleTeacherSelect() {
    if (this.mailSettingTeacherIDs.length === this.teachers.length) {
      this.teacherAll = true;
    } else {
      this.teacherAll = false;
    }
  }

  handleTeacherAllSelect(e: any) {
    this.teacherAll = e.target.checked;
    let ids: number[] = this.viewTeachers.map((teacher: Teacher) => {
      return teacher.teacherID;
    });
    if (this.teacherAll) {
      this.mailSetting.ids = this.mailSettingTeacherIDs.concat(ids).filter((elem, index, self) => self.indexOf(elem) === index);
    } else {
      this.mailSetting.ids = this.mailSettingTeacherIDs.filter(id => ids.indexOf(id) === -1);
    }
  }
}
